<script>
    let x;// =  Math.random()* 50;//window.innerWidth/2;
    let y;// =  Math.random()* 50;//window.innerHeight/2;
    let w = Math.min(890,window.innerWidth*0.95);//400;
    let h = window.innerHeight*0.8;

    let checkPortrait = window.matchMedia("only screen and (max-width: 760px)").matches;
    let checkLandscape = window.matchMedia("only screen and (max-height: 760px)").matches;
    let isMobile = !!navigator.maxTouchPoints && (checkPortrait || checkLandscape);

    let isFullScreen = false;
    let storedSettings = {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
    }

    export let active = false;
    export let depth;
    export let name;
    
    export let toFront = ()=>{
     };
    export let minimise = ()=>{
     };


    x = 142 + (depth + 1) * 25;
    y = 20 + (depth + 1) * 25;



    let moving = false;
    let resizing = false;

    function onMouseDown() {
        moving = true;
        toFront();
    }

    function onCornerDown(){
        resizing = true;
        toFront();
    }

    let touchDrag = false;
    let initialX;
    let initialY;
    let xOffset = 0;
    let yOffset = 0;

    function touchStart(e) {
        
        xOffset = x;
        yOffset = y;
        
        initialX = e.touches[0].clientX - xOffset;
        initialY = e.touches[0].clientY - yOffset;
        
        toFront();
        touchDrag = true;
    }

    function touchEnd() {
        initialX = x;
        initialY = y;
        touchDrag = false;
    }

    function touchMove(e) {

        if (touchDrag && !isFullScreen && !isMobile) {
            isFullScreen = false;

            x = e.touches[0].clientX - initialX;
            y = e.touches[0].clientY - initialY;

            xOffset = x;
            yOffset = y;
        }
    }

    function onMouseMove(e) {
        
        if (moving) {
            isFullScreen = false;
            x += e.movementX;
            y += e.movementY;

            // x = Math.max(x,0);
            y = Math.max(y,-10);
        }

        if(resizing) {
            isFullScreen = false;
            w += e.movementX;
            h += e.movementY;

            w = Math.min(w,window.innerWidth - 3);
            h = Math.min(h,window.innerHeight - 7);

            w = Math.max(w,85);
            h = Math.max(h,110);
        }
    }

    function onMouseUp() {
        moving = false;
        resizing = false;
    }
    function toggleFullScreen(){
        if (!isMobile) {
            if(!isFullScreen){
                storedSettings = {
                    x: x,
                    y: y,
                    w: w,
                    h: h
                }
                x = 0;
                y = 0;
                w = window.innerWidth - 3;
                h = window.innerHeight - 7;

            }else{
                x = storedSettings.x;
                y = storedSettings.y;
                w = storedSettings.w;
                h = storedSettings.h;
            }
            isFullScreen = !isFullScreen;
        }
    }
    function refreshFullScreen(){
        if(isFullScreen){
            x = 0;
            y = 0;
            w = window.innerWidth - 3;
            h = window.innerHeight - 7;
        }
    }

    if (isMobile) {
        storedSettings = {
            x: x,
            y: y,
            w: w,
            h: h
        }
        x = 0;
        y = 0;
        w = window.innerWidth - 3;
        h = window.innerHeight - 7;
    }

    window.addEventListener('orientationchange', function(event) {
        isFullScreen = true;
        refreshFullScreen();
    });

</script>

<style>
    s{
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }

    .active{
        background: #aeaeae;
        /*background: red;*/
    }
    .inactive{
        background: #7d7d7d;
    }
    .st{
        /*margin-top:2px;*/
        border-top: solid white 2px;
    }
    .sb{
        /*margin-bottom:2px;*/
        border-bottom: solid black 2px;
    }
    .sr{
        /*margin-right:2px;*/
        border-right: solid black 2px;
    }
    .sl{
        /*margin-left:2px;*/
        border-left: solid white 2px;
    }

    .window{
        /*background: gainsboro;*/
        /*border: 2px solid black;*/
        position: fixed;
        padding-top: 2px;
        padding-left: 2px;
        padding-right: 2px;
        padding-bottom: 16px;

    }

    .window-content{
        padding-left: 34px;
        padding-top: 10px;
        padding-right: 34px;
        padding-bottom: 25px;
        overflow: scroll;
        flex-grow: 1000;
        /*width:calc(100% - 5px);*/
        /*height:calc(100% - 50px);*/
    }
    .main-section{
        width:calc(100%);
        height:calc(100% - 52px);
        display: flex;
        flex-direction: row;
    }

    .grabber{
        position:absolute;
        width:15px;
        height:15px;
        /*background: red;*/
        cursor: se-resize;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .titleBar {
        /*width:100%;*/
        cursor: move;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        background: white;

        height: 32px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 24px;

        /*display: flex;*/
        /*flex-direction: row;*/
        /*align-items: center;*/
        /*justify-content: center;*/

    }
    .titleBar .label{
        width:calc(100% - 12px);
        float:left;
        margin-top:3px;
        padding-left:12px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        /*background:red;*/
    }


    .subtitleBar {
        display:flex;
        justify-content: space-between;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

    }
    .subtitleBar .minimise {
        width:45px;
        height: 26px;
        font-size: 2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .subtitleBar .label{
        height: 26px;
        line-height: 26px;
        /*background: green;*/
        flex-grow: 1000;
        padding-left: 5px;
        font-size: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .subtitleBar .fullScreen{
        flex-grow: 1;
        width: 30px;
        height: 26px;
        border-right: 2px solid #000;
    }
    .windowControl{
        cursor: pointer;
    }
    .windowControl:hover{
        background: rgba(255,255,255,0.5);
    }



    .left-bar{
        flex-grow: 1;
        width:0px;
    }

    .fullScreen{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .disable {
        display: none;
    }

</style>

<div class="window {active?'active':'inactive'}"
    style="width:{w}px; height:{h}px; left: {x}px; top: {y}px; z-index:{depth}"
    on:mousedown={toFront}
    >

    <div class="titleBar sl st sb s"
         on:mousedown={onMouseDown}
         on:touchstart|preventDefault={touchStart}
         on:touchend={touchEnd}
    >
        <span class="label">
            POW NFT DROPS
        </span>
    </div>
    <div class="subtitleBar">
        <span class="label  sl st sb sr s">{name}</span>

        <span class="minimise sl st sb sr s windowControl" on:click={minimise}>
            <img src="/images/Icon_CloseToDrawerTTCrop.png" style="width:34px; height:18px;" alt="Close Window Icon" />
        </span>
        <span class="fullScreen sl st sb s windowControl {isMobile ? "disable" : ""}" on:click={toggleFullScreen}>
            <img src="/images/Icon_Enlarge_ScreenTTCorp.png" style="height:18px; width:20px;" alt="Fullscreen Icon" />
        </span>
    </div>
    <div class="main-section">
        <span class="left-bar s sl sr sb">
            &nbsp;
        </span>
        <span class="window-content">
            <slot></slot>
        </span>
    </div>

    <div class="grabber"
        style="top:{h}px; left:{w-10}px;" on:mousedown={onCornerDown}
    >&nbsp;</div>
</div>


<svelte:window
    on:mouseup={onMouseUp}
    on:pointermove={onMouseMove}
    on:touchmove={touchMove}
    on:resize={refreshFullScreen} />